import $ from "jquery";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const useMobilemenu = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    try {
      $(".td_menu_toggle").off("click");
      $(".td_munu_dropdown_toggle").off("click");
      $(".menu-item-has-children > a").off("click");
      $(".td_header_dropdown_btn").off("click");

      $(".td_menu_toggle").remove();
      $(".td_munu_dropdown_toggle").remove();

      $(".td_nav").append('<span class="td_menu_toggle"><span></span></span>');
      $(".menu-item-has-children").append(
        '<span class="td_munu_dropdown_toggle"><span></span></span>',
      );
      $(".td_menu_toggle").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(this)
          .toggleClass("td_toggle_active")
          .siblings(".td_nav_list_wrap")
          .toggleClass("td_active");
      });
      $(".td_munu_dropdown_toggle").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).toggleClass("active").siblings("ul").slideToggle();
        $(this).parent().toggleClass("active");
      });

      $(".menu-item-has-children > a").on("click", function (e) {
        const isPublicNoticeLink =
          $(this).attr("href")?.trim().toLowerCase() === "/#notice_tab_1";
        const submenu = $(this).siblings("ul");
        if (
          submenu.length &&
          $(".td_menu_toggle").is(":visible") &&
          !isPublicNoticeLink
        ) {
          e.preventDefault();
          e.stopPropagation();
          const toggle = $(this).siblings(".td_munu_dropdown_toggle");
          toggle.toggleClass("active");
          $(this).parent().toggleClass("active");
          submenu.slideToggle();
        }
      });

      $(".td_header_dropdown_btn").on("click", function () {
        $(this).toggleClass("active");
      });
    } catch (error) {
      console.log(error);
    }
  }, [pathname]);
};
